import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { ParagonEditor } from "../Editor/ParagonEditor";
import { createUpdateNote, modifyUpdateNote } from "../../services/UpdateNotesService";
import { FormFeedback } from "../FormFeedback";

function isEditorEmpty(html) {
  return !html || html.trim() === '' || html === '<p><br></p>';
}

export default function UpdateNoteForm({ announcement, onSaved }) {
  const [title,      setTitle]      = useState('');
  const [date,       setDate]       = useState('');
  const [content,    setContent]    = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error,      setError]      = useState(null);

  useEffect(() => {
    if (announcement) {
      setTitle(announcement.Title);
      setDate(new Date(announcement.Date).toISOString().split('T')[0]);
      setContent(announcement.Content);
    } else {
      setTitle('');
      setDate(new Date().toISOString().split('T')[0]);
      setContent('');
    }
    setError(null);
  }, [announcement]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (isEditorEmpty(content)) {
      setError('Content is required.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      let id;
      if (announcement) {
        await modifyUpdateNote(announcement.ID, title, content, date);
        id = announcement.ID;
      } else {
        id = await createUpdateNote(title, content, date);
      }
      onSaved({ id, title, date, content });
    } catch {
      setError('Failed to save announcement. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Form className="modal-form" onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="ann-title">
        <Form.Label>Title</Form.Label>
        <Form.Control
          type="text"
          placeholder="Title"
          required
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="ann-date">
        <Form.Label>Date</Form.Label>
        <Form.Control
          type="date"
          required
          value={date}
          onChange={e => setDate(e.target.value)}
        />
      </Form.Group>

      <div className="mb-3">
        <Form.Label>Content</Form.Label>
        {/* key forces full remount when switching between create/edit targets */}
        <ParagonEditor
          key={announcement?.ID ?? 'new'}
          value={content}
          onChange={setContent}
          placeholder="Write your announcement…"
        />
      </div>

      <FormFeedback type="error" message={error} />

      <div className="modal-form-actions">
        <Button variant="success" type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : (announcement ? 'Save Changes' : 'Create')}
        </Button>
      </div>
    </Form>
  );
}
